import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import upload from "../assets/images/upload.svg";
import filtericon from "../assets/images/Filter-Icon.svg";
import StyledTable from "../Reusablecomponents/UITable/UITable";
import ReusablePagination from "../Reusablecomponents/ReusablePagination";
import { TripTypeEnum, TripStatusEnum, TripStatusForCustom } from "../Common/constant";
import {
  Card,
  Badge,
  Avatar,
  Form,
  Select,
  Row,
  Col,
  Button,
  Modal,
  DatePicker,
  Spin,
  message,
} from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import {
  PieChart,
  Pie,
  Legend,
  Cell,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  LabelList,
} from "recharts";
import { CALL_API } from "../Common/api";
import dayjs from "dayjs";
import { CSVLink } from "react-csv";
 

const Customstyle = styled.div`
  background-color: white;
  padding: 15px;
  border-radius: 8px;
  .title {
    font-size: 16px;
    font-weight: 400;
    color: #5f6d8c;
  }
  .carddiv {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .card-item {
    flex: 1;
    max-width: 49%;
    height: 360px;
    box-sizing: border-box;
  }
  .cardtitle {
    font-weight: 500;
    font-size: 16px;
  }
  .total {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .Custom {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .badg {
    padding: 5px;
  }
  .badg .ant-badge-count {
    font-size: 12px;
    height: 16px;
    min-width: 16px;
    line-height: 16px;
  }
  .ab {
    display: inline-block; /* Allow width and height to apply */
    width: 4px !important;
    height: 4px !important;
    background-color: #e4a400;
    border-radius: 50%;
    margin-right: 4px;
    margin-bottom: 1px !important;
  }
  .titlestyle {
    text-align: center;
  }
  .status-container {
    display: flex;
    align-items: center;
  }

  .status-circle {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 8px;
  }

  .completed {
    background-color: #00bc13;
  }

  .incomplete {
    background-color: blue;
  }
  .down-arrow {
    margin-left: 8px;
    font-size: 14px;
    color: green;
  }

  @media screen and (max-width: 768px) {
    .card-item {
      max-width: 100%;
    }
  }

  .ant-table-tbody > tr:nth-child(odd) {
    background-color: rgb(237, 255, 241);
  }

  .status-container {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 8px;
}

.completed {
  background-color: #00BC13; 
}

.in-progress {
  background-color: #007EEA; 
}

.unassigned {
    background-color: red; /* Red */
}

.unknown {
  background-color: gray; /* Gray */
}
`;
const { Option } = Select;

function CustomDashboard() {
  const csvLinkEl = useRef();
  // const COLORS = ["#00BC13", "#007EEA"];
  // const COLORS = ["#007EEA", "#00BC13"];
  const COLORS = ["#007EEA", "#00BC13"]; // Blue, Green
  const barcolor = ["#9FE4FF", "#7BFF88"];
  const [tripStatus, setTripStatus] = useState([]);
  const [tripStatusLoading, setTripStatusLoading] = useState(false);
  const [tripStatusChart, setTripStatusChart] = useState([]);
  console.log(
    tripStatusChart , "tripStatusChart->"
  )
  const [vehicleUtilization, setVehicleUtilization] = useState([]);
  const [tripStatusChartLoading, setTripStatusChartLoading] = useState(false);
  const [vehicleUtilizationLoading, setVehicleUtilizationLoading] =
    useState(false);
  const [Customdata, setCustomdata] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);

  const [tableLoading, setTableLoading] = useState(false);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList
  );
  const vehicleListone = useSelector((state) => state?.authTracking?.vehicleList);

console.log(vehicleListone , "vehicleList-->")
  //FILTER
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [filterCount, setFilterCount] = useState(0);
  console.log(
   filterCount , "filterCount->" 
  )
  const [formValues, setFormValues] = useState({});

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);
  const getFilterCount = () => {
    const values = form.getFieldsValue();
    const count = Object.values(values).filter(
      (val) => val !== undefined && val !== null && val !== ""
    ).length;
    setFilterCount(count);
  };

  //Pagination
  const [customPageSize, setCustomPageSize] = useState(10);
  const [customCurrentPage, setCustomCurrentPage] = useState(1);
  const [customTotal, setCustomTotal] = useState(0);
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);

  const handleCustomPageChange = (page, pageSize) => {
    setCustomCurrentPage(page);
    setCustomPageSize(pageSize);
    getCustomTableData(page, pageSize);
  };

  const handleCustomPageSizeChange = (size) => {
    setCustomPageSize(size);
    setCustomCurrentPage(1);
    getCustomTableData(1, size);
  };

  const getTripStatus = async () => {
    try {
      setTripStatusLoading(true);
      const { data } = await CALL_API("POST", "customeDashboard");
      setTripStatus(data);
      setTripStatusLoading(false);
    } catch (error) {
      console.error("[getTripStatus] error -->", error);
    }
  };

  useEffect(() => {
    getTripStatus();
  }, []);



  const BarCustomizedLabel = ({ x, y, width, height, value, index }) => {
    console.log("BarCustomizedLabel", index);

    const labelX = x + width / 2;
    const labelY = y - 10; // Put label above the bar
    const lineMidX = labelX + 80; // Shorter horizontal connector
    const lineEndX = lineMidX + 40;
    const lineEndY = labelY - 40;
const utilizedPercent = vehicleUtilization[0]
    ? Math.round(
        (vehicleUtilization[0].Utilized / (vehicleUtilization[0].Active )) * 100
      )
    : 0;
    return (
      <>
        {/* Horizontal line from the bar to the mid point */}
        <line
          x1={labelX}
          y1={labelY + 10}
          x2={lineMidX}
          y2={labelY + 10}
          stroke="#aaa"
          strokeWidth={1.5}
        />

        {/* Diagonal line from the mid point to the box */}
        <line
          x1={lineMidX}
          y1={labelY + 10}
          x2={lineEndX}
          y2={lineEndY}
          stroke="#aaa"
          strokeWidth={1.5}
        />

        {/* Green box (legend color block) */}
        <rect
          x={lineEndX - 35}
          y={lineEndY - 25}
          width={16}
          height={16}
          rx={3}
          fill="#7BFF88"
        />

        <text x={lineEndX - 10} y={lineEndY - 12} fontSize={16} fill="#5F6D8C">
          Utilized {utilizedPercent}%
        </text>
      </>
    );
  };

  const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  index,
}) => {
  const RADIAN = Math.PI / 180;
  const angle = -midAngle * RADIAN + 10;
  const line1Length = 0;
  const line2Length = 10;
  const textOffset = 8;
  const squareSize = 16;

  const x1 = cx + outerRadius * Math.cos(angle);
  const y1 = cy + outerRadius * Math.sin(angle);

  const x2 = cx + (outerRadius + line1Length) * Math.cos(angle);
  const y2 = cy + (outerRadius + line1Length) * Math.sin(angle);

  const fixedStartX = cx + outerRadius + line1Length + line2Length + 50;
  const x3 = fixedStartX;
  const y3 = y2;

  // Explicit color logic
  // const label = tripStatusChart[index]?.name;
  // console.log(label , "label->")
  // let color = "#00BC13"; // default green
  // if (label === "Trips in Progress") color = "#00BC13"; // green
  // if (label === "Trips Delivered") color = "#007EEA"; // blue


  const label = tripStatusChart[index]?.name;
let color = ""; // default blue
if (label === "Trips in Progress")   color = "#007EEA"; // blue
if (label === "Trips Delivered")       color = "#00BC13";

  return (
    <g>
      <path d={`M${x1},${y1}L${x2},${y2}`} stroke="#ccc" strokeWidth={1} fill="none" />
      <path d={`M${x2},${y2}L${x3 - line2Length},${y3}`} stroke="#ccc" strokeWidth={1} fill="none" />
      <rect
        x={x3}
        y={y3 - squareSize / 2}
        width={squareSize}
        height={squareSize}
        rx={3}
        fill={color}
      />
      <text
        x={x3 + squareSize + textOffset}
        y={y3}
        fill="#5F6D8C"
        fontSize={15}
        textAnchor="start"
        dominantBaseline="central"
      >
        {tripStatusChart[index]
          ? `${tripStatusChart[index].name} ${tripStatusChart[index].value}`
          : ""}
      </text>
    </g>
  );
};

  // const renderCustomizedLabel = ({
  //   cx,
  //   cy,
  //   midAngle,
  //   innerRadius,
  //   outerRadius,
  //   index,
  // }) => {
  //   const RADIAN = Math.PI / 180;
  //   const angle = -midAngle * RADIAN + 10;

  //   const line1Length = 0; // Adjust as needed
  //   const line2Length = 10; // This will determine the starting x-position of the label
  //   const textOffset = 8;
  //   const squareSize = 16;

  //   const x1 = cx + outerRadius * Math.cos(angle);
  //   const y1 = cy + outerRadius * Math.sin(angle);

  //   const x2 = cx + (outerRadius + line1Length) * Math.cos(angle);
  //   const y2 = cy + (outerRadius + line1Length) * Math.sin(angle);

  //   // Fixed x-coordinate for the start of the horizontal line and the square
  //   const fixedStartX = cx + outerRadius + line1Length + line2Length + 50;

  //   const x3 = fixedStartX;
  //   const y3 = y2;

  //   const color = COLORS[index % COLORS.length];

  //   return (
  //     <g>
  //       {/* Line 1: from pie to outside */}
  //       <path
  //         d={`M${x1},${y1}L${x2},${y2}`}
  //         stroke="#ccc"
  //         strokeWidth={1}
  //         fill="none"
  //       />

  //       {/* Line 2: horizontal to the fixed start position */}
  //       <path
  //         d={`M${x2},${y2}L${x3 - line2Length},${y3}`}
  //         stroke="#ccc"
  //         strokeWidth={1}
  //         fill="none"
  //       />

  //       {/* Square box for legend */}
  //       <rect
  //         x={x3}
  //         y={y3 - squareSize / 2}
  //         width={squareSize}
  //         height={squareSize}
  //         rx={3}
  //         fill={color}
  //       />

  //       {/* Text label */}
  //       <text
  //         // x={x3 + squareSize + textOffset}
  //         // y={y3}

  //             x={x3 + squareSize + textOffset}
  //         y={y3}
  //         fill="#5F6D8C"
  //         fontSize={15}
  //         textAnchor="start" // Keep textAnchor as 'start'
  //         dominantBaseline="central"
  //       >
  //         {console.log(tripStatusChart[index] , "chartindex->")}
  //         {tripStatusChart[index]
  //           ? `${tripStatusChart[index].name} ${tripStatusChart[index].value}`
  //           : ""}
  //       </text>
  //     </g>
  //   );
  // };

  const getTripStatusChart = async () => {
    try {
      setTripStatusChartLoading(true);
      const res = await CALL_API("GET", "custom/trip_status");
      console.log("Trip Status API Response:", res);
      const result = res?.data || {};

      // const chartData = [
      //           { name: "Trips in Progress", value: result.inProgress || 0 },
      //   { name: "Trips Delivered", value: result.delivered || 0 },
      // ];
      let chartData = [
  { name: "Trips in Progress", value: result.inProgress || 0 }, // Blue
  { name: "Trips Delivered", value: result.delivered || 0 },    // Green
];
    chartData = chartData.filter(item => item.value > 0);
console.log(chartData , "chartData->")

setTripStatusChart(chartData);
      console.log("Trip Chart Data:", chartData);
      setTripStatusChart(chartData);
    } catch (error) {
      console.error("Error fetching trip status", error);
    } finally {
      setTripStatusChartLoading(false);
    }
  };

  console.log("userInfo", userInfo?.MCID);
  const getVehicleUtilization = async () => {
    try {
      setVehicleUtilizationLoading(true);
      const res = await CALL_API(
        "GET",
        `custom/vehicle_utilized?mcid=${userInfo?.MCID}`
      );
      console.log("Vehicle Utilization API Response:", res);
      const result = res?.data || {};
      const chartData = [
        {
          name: "Active   Utilized",
          Active: result.activeVehicles || 0,
          Utilized: result.usedVehicles || 0,
        },
      ];
      setVehicleUtilization(chartData);
    } catch (error) {
      console.error("Error fetching vehicle utilization", error);
    } finally {
      setVehicleUtilizationLoading(false);
    }
  };
console.log(formValues?.daterange ,  "selectedDateselectedDate")
  const getCustomTableData = async (
    page = customCurrentPage,
    perPage = customPageSize
  ) => {
    setTableLoading(true);
    try {
      const tripTypeString = TripTypeEnum.find(
        (item) => item.value === formValues?.tripType
      )?.name;

      const payload = {
        Duration: "Desc",
        // Date: selectedDate?.[1]
        //   ? dayjs(selectedDate[1]).format("YYYY-MM-DD")
        //   : dayjs().format("YYYY-MM-DD"),
         Date: formValues?.daterange ? dayjs(formValues?.daterange).format("YYYY-MM-DD"): "", 
        RECNAME: userInfo?.consigneeList,
        Routes: "",
        Invoice: "",
        Package: "",
        TRIPTYPE: tripTypeString,
        VEHID: formValues?.vehicle || 0,
        CUSTCOLS: "",
        Status: formValues?.Status || null,
        mcId: userInfo?.MCID,
        PerPage: perPage,
        CurPage: page,
      };

      const { data } = await CALL_API(
        "POST",
        "custom/getAllCustomDashData",
        payload
      );
      setCustomdata(data?.data || []);
      setCustomTotal(data?.total || 0); // If backend returns total
    } catch (error) {
      console.error("[getCustomTableData] error -->", error);
    } finally {
      setTableLoading(false);
       }
  };
useEffect(()=> {
getCustomTableData()
} , [  formValues?.daterange
])


  const prepareCSV = async (event, done) => {
    try {
      setCSVLoader(true);
      const tripTypeString = TripTypeEnum.find(
        (item) => item.value === formValues?.tripType
      )?.name;

      const payload = {
        Duration: "Desc",
        Date: selectedDate?.[1]
          ? dayjs(selectedDate[1]).format("YYYY-MM-DD")
          : dayjs().format("YYYY-MM-DD"),
        RECNAME: userInfo?.consigneeList,
        Routes: "",
        Invoice: "",
        Package: "",
        TRIPTYPE: tripTypeString,
        VEHID: formValues?.vehicle || 0,
        CUSTCOLS: "",
        mcId: userInfo?.MCID || 0,
        PerPage: customTotal,
        CurPage: 1,
      };

      const { data } = await CALL_API(
        "POST",
        "custom/getAllCustomDashData",
        payload
      );
      setCSVLoader(false);
      if (data?.data?.length > 0) {
        setCSVList(
          data?.data?.map((item) => {
            const tripStatusLabel = TripStatusMap[item.TRIPSTATUS] || "Unknown";

            return {
              Vehicle: item.REGNO || "-",
              Status: tripStatusLabel,
              Consignment: item.Consignments || "-",
              "Delivered / Ordered": `${item.Delivered || 0} / ${
                item.Ordered || 0
              }`,
              "Offloaded Consignments (Day)": item.TotalConsignment_DAY || 0,
              "Offloaded Consignments (Month)":
                item.TotalConsignment_MONTH || 0,
              "Total KMs (Month)": item.TotalKM ?? 0,
            };
          })
        );

        setTimeout(() => {
          csvLinkEl.current.link.click();
        });
      } else {
        message.error("No data available to download.");
      }
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };

  useEffect(() => {
    getTripStatusChart();
    getVehicleUtilization();
    getCustomTableData(customCurrentPage, customPageSize);
  }, [formValues, selectedDate, customCurrentPage, customPageSize]);

  const hasTripStatusData = tripStatusChart?.some((item) => item.value > 0);
  const hasVehicleUtilizationData = vehicleUtilization?.some(
    (item) => item.Active > 0 || item.Utilized > 0
  );
  const TripStatusMap = TripStatusEnum.reduce((acc, cur) => {
    acc[cur.value] = cur.label;
    return acc;
  }, {});

  const CustomColumn = [
    {
      title: "Vehicle",
      dataIndex: "REGNO",
      key: "REGNO",
      render: (text, record) => {
        const statusLabel = TripStatusMap[record.TRIPSTATUS];
        return (
          <div>
            <span>{text}</span>
            {statusLabel === "Completed" ? (
              <div
                style={{
                  color: "#E4A400",
                  fontWeight: "400",
                  marginTop: "4px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span className="ab"></span>
                Safari
              </div>
            ) : statusLabel === "In Progress" ? (
              <div>
                <i> Local</i>
              </div>
            ) : null}
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "Color",
      key: "Color",
      render: (value , record) => {
        console.log(record , "valuevaluevs")
        let label = "Unknown";
        let statusClass = "unknown";
    
        // Map Color values to labels and styles
        if (value === 1) {
          label = "Completed";
          statusClass = "completed";
        } else if (value === 2) {
          label = "In Progress";
          statusClass = "in-progress";
        } else if (value === 0) {
          label = "Unassigned";
          statusClass = "unassigned";
        }
    
        return (
          <div className="status-container">
            <span className={`status-circle ${statusClass}`}></span>
            {label}
          </div>
        );
      },
    },
    {
  title: "Consignment",
  dataIndex: "Consignments",
  key: "Consignments",
  render: (text, record) => {
     console.table(text , "texttext")
    console.log(typeof(text), record, "text->");
const input = "Nakuru Customer0 , Nakuru Customer0 , Nakuru Customer0";

const extractnamestoarray = text.split(",").map(item => item.trim().slice(0,-1));
console.log(typeof(extractnamestoarray), extractnamestoarray,"extractnamestoarray->")


    const getColor = (value) => {
      console.log(value, "value->");
      const lastChar = text.slice(-1); 
      console.log(lastChar, "lastChar->");
      return lastChar === "1" ?  "text-success" : "" ;
    };

    return (
      <>
      {extractnamestoarray.map((item, index) => {
return(
    <p className={getColor(item)}
    key={index}>{item}</p>
)
       })}
        
      </>
    );
  }
}
,
    {
      title: "Delivered / Ordered",
      key: "DeliveredOrdered",
      align: "center",
      render: (text, record) => (
        <span>
          {(record.Delivered ?? 0)}/{(record.Ordered ?? 0)}
        </span>
      ),
    },
    {
      title: (
        <>
          <div>Offloaded Consignments</div>
          <div className="titlestyle">(Day)</div>
        </>
      ),
      dataIndex: "TotalConsignment_DAY",
      key: "TotalConsignment_DAY",
      align: "center",
      render: (text) => text ?? 0,
    },
    {
      title: (
        <>
          <div>Offloaded Consignments</div>
          <div className="titlestyle">(Month)</div>
        </>
      ),
      dataIndex: "TotalConsignment_MONTH",
      key: "TotalConsignment_MONTH",
      align: "center",
      render: (text) => text ?? 0,
    },    
    {
      title: (
        <>
          <div>Total Kms </div>
          <div className="titlestyle">(Month)</div>
        </>
      ),
      dataIndex: "TotalKM",
      key: "TotalKM",
      align: "center",
      render: (text) => text ?? 0,
    },
  ];
  const Customdata1 = [
    {
      key: "1",
      Vehicle: "KA1234532",
      Status: "Completed",
      Consignment: "Pawni Oil Mombasa",
      DeliveredOrdered: "1/1",
      Offloadedday: "1",
      Offloadedmonths: "10",
      TotalKms: "35",
    },
    {
      key: "2",
      Vehicle: "KA1234532",
      Status: "In Progress",
      Consignment: "Pawni Oil Mombasa",
      DeliveredOrdered: "1/1",
      Offloadedday: "1",
      Offloadedmonths: "10",
      TotalKms: "35",
    },
    {
      key: "3",
      Vehicle: "KA1234532",
      Status: "Completed",
      Consignment: "Pawni Oil Mombasa",
      DeliveredOrdered: "1/1",
      Offloadedday: "1",
      Offloadedmonths: "10",
      TotalKms: "35",
    },
    {
      key: "4",
      Vehicle: "KA1234532",
      Status: "In Progress",
      Consignment: "Pawni Oil Mombasa",
      DeliveredOrdered: "1/5",
      Offloadedday: "1",
      Offloadedmonths: "10",
      TotalKms: "35",
    },
    {
      key: "5",
      Vehicle: "KA1234532",
      Status: "Completed",
      Consignment: "Pawni Oil Mombasa",
      DeliveredOrdered: "1/1",
      Offloadedday: "1",
      Offloadedmonths: "10",
      TotalKms: "35",
    },
  ];
  return (
    <Customstyle>
      <p className="title">Chart View</p>
      <br />
      <div className="carddiv">
        <Card className="card-item">
          <p className="cardtitle">Trip Status</p>
          {tripStatusChartLoading ? (
            <p>Loading...</p>
          ) : hasTripStatusData ? (
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={tripStatusChart}
                 cx="30%"
                   cy="50%"
                   innerRadius={68}
                 outerRadius={96}
                 paddingAngle={-15}
                 cornerRadius={40}
                 startAngle={330} // Starts at the top
                 endAngle={-250}
                dataKey="value"
                 labelLine={false}
                   label={renderCustomizedLabel}
                >
                  {tripStatusChart.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                      stroke={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          ) : (
            <div
              style={{
                height: 250,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <p style={{ color: "#999" }}>No Data Available</p>
            </div>
          )}
        </Card>
        <Card className="card-item">
          <p className="cardtitle">Vehicle Utilization</p>
          {vehicleUtilizationLoading ? (
            <p>Loading...</p>
          ) : hasVehicleUtilizationData ? (
            // <ResponsiveContainer width="50%" height={300}>
            //   <BarChart
            //     data={vehicleUtilization}
            //     margin={{
            //       top: 40,
            //       right: 30,
            //       left: 20,
            //       bottom: 5,
            //     }}
            //     barCategoryGap="25%"
            //     barGap={55}
            //     barSize={30}
            //   >
            //     <CartesianGrid stroke="none" />
            //     <XAxis dataKey="name" axisLine={false} tickLine={false} />
            //     {/* <YAxis axisLine={false} tickLine={false} /> */}
            //     <Tooltip

            //     />
            //     <Bar
            //       dataKey="Active"
            //       name="Active"
            //       fill="#9FE4FF"
            //       radius={[5, 5, 0, 0]}
            //       label={BarCustomizedLabel}
            //     ></Bar>
            //     <Bar
            //       label={BarCustomizedLabel}
            //       dataKey="Utilized"
            //       name="Utilized"
            //       fill="#7BFF88"
            //       radius={[5, 5, 0, 0]}
            //     />
            //     {vehicleUtilization.map((entry, index) => (
            //       <Cell
            //         key={`cell-${index}`}
            //         fill={COLORS[index % COLORS.length]}
            //         stroke={COLORS[index % COLORS.length]}
            //       />
            //     ))}
            //   </BarChart>
            // </ResponsiveContainer>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart
                data={vehicleUtilization}
                margin={{
                  top: 40,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
                barCategoryGap="25%"
                barGap={40}
                barSize={52}
              >
                <CartesianGrid stroke="none" />
                <XAxis
                  dataKey="name"
                  axisLine={false}
                  tickLine={false}
                  interval={0}
                  padding={{ left: 20, right: 200 }}
                  tick={({ x, y, payload }) => {
                    return (
                      <>
                        <text
                          x={x - 65} // move "Active" left to match bar
                          y={y + 20}
                          textAnchor="start"
                          fontSize={14}
                          fill="#5F6D8C"
                        >
                          Active
                        </text>
                        <text
                          x={x + 25} // move "Utilized" right to match bar
                          y={y + 20}
                          textAnchor="start"
                          fontSize={14}
                          fill="#5F6D8C"
                        >
                          Utilized
                        </text>
                      </>
                    );
                  }}
                />
                <Tooltip />
                <Bar
                  dataKey="Active"
                  name="Active"
                  fill="#9FE4FF"
                  radius={[4, 4, 0, 0]}
                  label={""}
                
                >
                  <LabelList dataKey="Active" position="Middle" />
                </Bar>
                <Bar
                  dataKey="Utilized"
                  name="Utilized"
                  fill="#7BFF88"
                  radius={[4, 4, 0, 0]}
                  label={BarCustomizedLabel} 
                >
                  <LabelList dataKey="Utilized" position="Middle" />
                </Bar>
                {vehicleUtilization.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                    stroke={COLORS[index % COLORS.length]}
                  />
                ))}
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <div
              style={{
                height: 325,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <p style={{ color: "#999" }}>No Data Available</p>
            </div>
          )}
        </Card>
      </div>
      <br />
      <div className="total">
        <div className="head">
          <p>{customTotal} Vehicles </p>
        </div>
        <div className="Custom">
          <div>
            <Spin spinning={CSVLoader}>
              <img
                src={upload}
                alt="Upload Icon"
                className="hover-image"
                onClick={prepareCSV}
              />
            </Spin>
            <CSVLink
              data={CSVList}
              filename={"Trip Break Report.csv"}
              asyncOnClick={true}
              ref={csvLinkEl}
            />
          </div>
          <div onClick={showModal}>
            <Badge count={filterCount} className="badg">
              <Avatar
                shape="circle"
                size={26}
                src={filtericon}
                className="filterstyle"
              />
            </Badge>
          </div>
        </div>
      </div>
      <br />
      <StyledTable
        dataSource={Customdata}
        columns={CustomColumn}
        pagination={false}
      />
      <ReusablePagination
        pageSize={customPageSize}
        handlePageSizeChange={handleCustomPageSizeChange}
        currentPage={customCurrentPage}
        total={customTotal}
        handlePageChange={handleCustomPageChange}
      />

      <Modal
        open={isModalOpen}
        onCancel={handleCancel}
        width={800}
        footer={
          <Button
            onClick={() => {
              form.resetFields();
              setFormValues({});
              setFilterCount(0);
            }}
          >
            Clear All
          </Button>
        }
      >
        <Row>
          <Col span={24}>
            <div className="container_for_kpi_filter">
              <h6 className="Filter_for_clickablerow">
                Filter ({filterCount})
              </h6>
            </div>
          </Col>
        </Row>

        <Form
          form={form}
          layout="vertical"
          onValuesChange={(changed, all) => {

            console.log(all , "setFormValues")
               console.log(all, "11111111");
            setFormValues(all);
            getFilterCount();
          }}
        >
            {console.log(formValues , "formValues12->")}
          {console.log(formValues.Status , "formValues1242->")}
          <Row gutter={16}>
            <Col xs={24} sm={12} md={6}>
              <Form.Item label="Vehicle" name="vehicle">
                <Select
                  showSearch
                  allowClear
                  optionFilterProp="children"
                  options={vehicleListone?.map((item) => ({
                    label: item.REGNO,
                    value: item.VEHID,
                  }))}
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>
{/* 
            <Col xs={24} sm={12} md={6}>
              <Form.Item label="Consignee" name="consignee">
                <Select
                  showSearch
                  allowClear
                  optionFilterProp="children"
                  options={consigneeList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))}
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col> */}
              <Col xs={24} sm={24} md={6}>
                          <Form.Item label="Date" name="daterange">
                           <DatePicker/>
                          </Form.Item>
                        </Col>

            <Col xs={24} sm={12} md={6}>
              <Form.Item label="Trip Type
              " name="tripType">
                <Select showSearch allowClear>
                  <Option value={2}>Safari</Option>
                  <Option value={1}>Local</Option>
                </Select>
              </Form.Item>
            </Col>


             <Col xs={24} sm={12} md={6}>
              <Form.Item label="Status" name="Status">
                <Select
                  showSearch
                  allowClear
                  optionFilterProp="children"
                  options={TripStatusForCustom?.map((item) => ({
                    label: item.label,
                    value: item.value,
                  }))}
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </Customstyle>
  );
}
export default CustomDashboard;
